function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M22 44V0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z",
  fill: "#24C952"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M34.2222 22H9.77777C9.45361 22 9.14274 22.1288 8.91352 22.358C8.68431 22.5872 8.55554 22.8981 8.55554 23.2222C8.55554 23.5464 8.68431 23.8573 8.91352 24.0865C9.14274 24.3157 9.45361 24.4444 9.77777 24.4444H11V39.1111H33V24.4444H34.2222C34.5464 24.4444 34.8572 24.3157 35.0865 24.0865C35.3157 23.8573 35.4444 23.5464 35.4444 23.2222C35.4444 22.8981 35.3157 22.5872 35.0865 22.358C34.8572 22.1288 34.5464 22 34.2222 22ZM30.5555 36.6667H13.4444V24.4444H30.5555V36.6667Z",
  fill: "#0E185B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33 15.9378H35.4444V18.3822H33V15.9378Z",
  fill: "#0E185B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M40.3333 15.7422C39.5538 16.0792 38.7311 16.3054 37.8889 16.4144V26.9989H35.5422V29.3333H40.3333V15.7422Z",
  fill: "#0E185B"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.1111 15.8889C6.1111 15.2406 6.36864 14.6188 6.82706 14.1604C7.28548 13.702 7.90724 13.4444 8.55555 13.4444H29.8467C29.203 12.717 28.6791 11.8919 28.2944 11H13.4444V8.55555H27.5855C27.5299 8.1505 27.5013 7.74219 27.5 7.33333C27.5014 6.92447 27.5299 6.51617 27.5855 6.11111H11V11H8.55555C7.25893 11 6.01542 11.5151 5.09858 12.4319C4.18173 13.3488 3.66666 14.5923 3.66666 15.8889V29.3333H8.45777V26.9989H6.1111V15.8889Z",
  fill: "#0E185B"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M36.6667 13.4444C40.0417 13.4444 42.7778 10.7084 42.7778 7.33333C42.7778 3.95826 40.0417 1.22222 36.6667 1.22222C33.2916 1.22222 30.5555 3.95826 30.5555 7.33333C30.5555 10.7084 33.2916 13.4444 36.6667 13.4444Z",
  fill: "#24C952"
});

var SvgPrinter = function SvgPrinter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrinter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/printer.6e6d5248.svg";
export { ForwardRef as ReactComponent };